//const api_url = "http://localhost:3005/api/";
//const api_url = "https://api.makkaan.com.pk/api/";
const api_url = "https://api.makkaan.com/api/";
export default api_url;